import LoadMore from "../../components/LoadMore";

export default function AdminShopOrders({ ctx }) {
  const { shopOrders, toggleShopOrder } = ctx;
  return (
    <div className="mt-10 space-y-3" data-testid="admin-shoporders">
      <p className="text-sm text-stone-500">Shop orders (kits &amp; merch). Cake kit orders automatically issue a single-use Vault access code shown below.</p>
      {shopOrders.length === 0 ? <p className="text-stone-500">No shop orders yet.</p> :
        shopOrders.map((o) => (
          <div key={o.id} data-testid={`shop-order-${o.id}`} className="p-4 bg-white border border-stone-200 rounded-xl flex justify-between gap-4 flex-wrap items-start">
            <div className="min-w-0">
              <p className="font-medium text-stone-900">{o.customer_name} · {o.customer_email}</p>
              <p className="text-sm text-stone-600 mt-1">
                {(o.items || []).map((it) => `${it.qty}× ${it.title}${it.size ? ` (${it.size})` : ""}`).join(", ")}
              </p>
              <p className="text-xs text-stone-500 mt-1">
                {o.fulfillment === "ship" ? "🚚 Ship" : "🏪 Pickup"} · Subtotal ${Number(o.subtotal || 0).toFixed(2)}{o.shipping_fee ? ` · Ship $${Number(o.shipping_fee).toFixed(2)}` : ""} · Total ${Number(o.total || 0).toFixed(2)}
              </p>
              {o.fulfillment === "ship" && o.shipping_address?.address && (
                <p className="text-xs text-stone-500 mt-1">
                  Ship to: {o.shipping_address.name} — {[o.shipping_address.address.line1, o.shipping_address.address.line2, o.shipping_address.address.city, o.shipping_address.address.state, o.shipping_address.address.postal_code].filter(Boolean).join(", ")}
                </p>
              )}
              {o.kit_codes?.length > 0 && (
                <p className="text-xs text-[#121212] mt-1">Access codes: {o.kit_codes.map((c) => c.code).join(", ")}</p>
              )}
            </div>
            <button
              data-testid={`shop-order-toggle-${o.id}`}
              onClick={() => toggleShopOrder(o)}
              className={`px-4 py-2 rounded-none text-xs tracking-[0.15em] uppercase font-bold h-fit transition-colors ${
                o.status === "fulfilled"
                  ? "bg-emerald-100 text-emerald-800 hover:bg-emerald-200"
                  : "bg-[#121212] text-[#F2E9D8] hover:bg-black"
              }`}
            >
              {o.status === "fulfilled" ? "Fulfilled ✓" : "Mark fulfilled"}
            </button>
          </div>
        ))}
      <LoadMore ctx={ctx} pkey="shoporders" label="Load older orders" />
    </div>
  );
}
